module.exports = __webpack_public_path__ + "img/lideranca_prata.9da7ddfc.png";